import React from 'react';
import { mockData } from '../mock';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-[#2D4A3E] to-[#1A3A2E] overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#E8F5E0] rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#E8F5E0] rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-6 py-32 pt-40 md:pt-48 relative z-10">
        <div className="max-w-3xl">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8 leading-tight">
            {mockData.company.tagline}
          </h1>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-[#E8F5E0] mb-12 leading-relaxed max-w-2xl">
            {mockData.company.description}
          </p>
        </div>

        <div className="mt-20">
          <p className="text-[#E8F5E0] text-sm mb-6">Unsere Fachpartner</p>
          <div className="grid grid-cols-3 md:grid-cols-6 gap-4 md:gap-6 lg:gap-8 items-center">
            {mockData.partners.map((partner, idx) => (
              <div
                key={idx}
                className="p-2 rounded-lg flex items-center justify-center h-56 transition-all duration-300 hover:scale-105"
              >
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="h-full w-full object-contain hover:scale-105 transition-all duration-300"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#F5F3ED] to-transparent"></div>
    </section>
  );
};

export default Hero;